import { PayloadAction } from '@reduxjs/toolkit';
import { DesignError, DesignState } from 'src/store/design/types';

const addDesignErrorReducer = (state: DesignState, action: PayloadAction<DesignError>) => {
  state.errors.push(action.payload);
};

export default addDesignErrorReducer;
